module.exports = __webpack_public_path__ + "static/media/courses-nav.8bd4cb84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Navigation/courses-nav.svg
// module id = 105
// module chunks = 0